import React, { useContext, useEffect } from "react";
import { storeAccountUnsupportedWhatsAppUrl } from "../storeSession";
import { AppContext } from "../../context";

/**
 * Terminal full-page view for archived / unsupported account types (e.g. home owner).
 * No header, nav, or dismiss — WhatsApp support only.
 */
export default function StoreAccountUnsupported() {
  const { closeAuthModal } = useContext(AppContext) || {};
  const whatsAppHref = storeAccountUnsupportedWhatsAppUrl();

  useEffect(() => {
    closeAuthModal?.();
  }, [closeAuthModal]);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 w-100 px-3 py-5 bg-white"
      style={{ margin: 0 }}
    >
      <div style={{ maxWidth: "32rem", width: "100%" }}>
        <h1 className="h4 fw-bold mb-3 text-center">
          Thanks for your interest!
        </h1>
        <p className="text-muted text-center mb-4">
          Sorry — we currently support interior companies only in B2B mode.
        </p>
        <div className="d-grid">
          <a
            href={whatsAppHref}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-success btn-lg"
          >
            <i className="fa-brands fa-whatsapp me-2" aria-hidden="true" />
            Need help with my account
          </a>
        </div>
      </div>
    </div>
  );
}
